import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.is-finite";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.regexp.to-string";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Base64Deriver =
/*#__PURE__*/
function () {
  function Base64Deriver() {
    _classCallCheck(this, Base64Deriver);
  }

  _createClass(Base64Deriver, null, [{
    key: "decodeNumber",
    value: function decodeNumber(data) {
      if (typeof data !== 'string') {
        return;
      }

      var decoded;
      /* istanbul ignore else */

      if (__SERVER__) {
        decoded = Buffer.from(data, 'base64').toString('ascii');
      } else {
        decoded = atob(data);
      }

      if (/^\d+$/.test(decoded)) {
        return parseInt(decoded, 10);
      }
    }
  }, {
    key: "encode",
    value: function encode(data) {
      // Only non-extended ASCII is supported for strings, across node/browser.
      var isValidString = typeof data === 'string' && /^[\x00-\x7F]*$/.test(data); // eslint-disable-line no-control-regex
      // NaN, +Infinity and -Infinity are type 'number' as well, we want to ignore those to avoid surprises.

      var isValidNumber = typeof data === 'number' && Number.isFinite(data);

      if (!(isValidString || isValidNumber)) {
        return;
      }

      var encoded;
      /* istanbul ignore else */

      if (__SERVER__) {
        encoded = Buffer.from(String(data)).toString('base64');
      } else {
        encoded = btoa(data);
      }

      return encoded;
    }
  }]);

  return Base64Deriver;
}();

export { Base64Deriver as default };